import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "./formLabel"

function FormRadioButton({ ...props }) {
  const { textDesc, form, field } = props

  const errors = getIn(form.errors, field.name)
  const touched = getIn(form.touched, field.name)

  const handleRadioButton = (buttonName, buttonValue) => {
    form.setFieldValue(buttonName, buttonValue)
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col md={6} xs={12} className="marginTop10px">
          <Col
            md={5}
            xs={5}
            className={
              "font18 height50 horizontal-align backgroundGrey cursorPointer float-left borderRadius8 YesNobutton " +
              (field.value ? "tick" : "")
            }
            onClick={() => {
              handleRadioButton(field.name, true)
            }}
            role="button"
            //tabIndex="0"
          >
            <b>Yes</b>
          </Col>
          <Col
            md={5}
            xs={5}
            className={
              "font18 height50 horizontal-align backgroundGrey cursorPointer float-right borderRadius8 YesNobutton " +
              (!field.value ? "tick" : "")
            }
            onClick={event => {
              handleRadioButton(field.name, false)
            }}
            role="button"
            //tabIndex="0"
          >
            <b>No</b>
          </Col>
          {errors && touched && <span className="InputError">{errors}</span>}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormRadioButton
